import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from '@stubhub/bamboo';

import ScrimBackground from '../react-scrim-background';
import SlideUp from '../react-slide-up';
import TopModule from '../react-top-module';

import './index.scss';

const DisclaimerButton = ({message, enabled, close}) => (
  <ScrimBackground enabled={enabled}>
    <SlideUp isComponentIn={enabled} classname="popuptall">
      <div className="DisclaimerButton">
        <TopModule disclaimerMsg={message} />
        <button className="DisclaimerButton__close" onClick={close} type="button">
          <Icon name="Close" className="DisclaimerButton__close-icon" />
        </button>
      </div>
    </SlideUp>
  </ScrimBackground>
);

DisclaimerButton.propTypes = {
  /**
   * Messages array
   */
  message: PropTypes.array,

  /**
   * If disclaimer is enabled
   */
  enabled: PropTypes.bool,

  /**
   * Close method when button is clicked
   */
  close: PropTypes.func,
};

export default DisclaimerButton;
